import React from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { ActionKeys } from '../Components/LastStepSubmitButtons';
import { IApplication } from '../../../../../typings/application/applications';

// components
import ContentForm from './ContentForm';
import SubmitForReviewButton from '../Components/SubmitForReviewButton';
import { SectionIntro } from '@ui';

interface IProps {
  application: IApplication;
  disabled?: boolean;
  canSendMessage?: boolean;
  onAction?: (key: ActionKeys | null) => void;
}

const ApplicationDocumentationWithRelationships = ({
  application,
  disabled,
  onAction,
  canSendMessage,
}: IProps) => {
  const { t } = useTranslation('onboarding');

  return (
    <>
      <SectionIntro
        title={t('application_documentation.title')}
        description={t('application_documentation.description')}
        appendToTitle={<SubmitForReviewButton />}
      />
      <ContentForm
        application={application}
        isViewOnly={disabled}
        onAction={onAction}
        canSendMessage={canSendMessage}
      />
    </>
  );
};

export default ApplicationDocumentationWithRelationships;
